import Navbar from "../components/navbar";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/sidebar";
import { useState } from "react";
import { cn } from "../utils/cn";
import { useTranslation } from "react-i18next";

const Layout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const { i18n } = useTranslation();

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
      <div
        className={cn(
          "text-gray-primary bg-purple-primary/10 dark:bg-purple-primary/40 transition-transform duration-300 ease-in-out max-h-max",
          {
            "md:pl-[20vw]": isSidebarOpen && i18n.language === "en",
            "md:pr-[20vw]": isSidebarOpen && i18n.language === "ar",
          }
        )}
      >
        <Navbar onMenuClick={toggleSidebar} isSidebarOpen={isSidebarOpen} />

        <main className="min-h-screen dark:text-black">
          <div
            className={cn(
              "px-6 py-4 md:p-10",
              !isSidebarOpen && " 2xl:max-w-[75vw] mx-auto 2xl:px-0 "
            )}
          >
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
};

export default Layout;
